import {selectCitiesCache, selectCurrentPlayer} from "../../redux/reducers/sharedStateReducer/selectors";
import {COMMON_BUILDING_TOKENS} from "../../constants/tokens";

/**
 * Фермы во всех городах игрока указанного цвета. Чистая часть getPlayerFarms —
 * нужна там, где кэш городов и цвет уже под рукой (например, в компонентах,
 * которые и так подписаны на них): подписываться отдельным селектором на
 * функцию, возвращающую каждый раз новый массив, значило бы перерисовываться
 * на любое изменение стора.
 *
 * @param {Object} citiesCache
 * @param {string} playerColor
 * @returns {string[]}
 */
export const getFarmsOfPlayerCities = (citiesCache, playerColor) => {
  const playerCities = (citiesCache || {})[playerColor] || [];

  const farms = [];
  for (const city of playerCities) {
    farms.push(...(city[COMMON_BUILDING_TOKENS.FARM] || []));
  }

  return farms;
}

/**
 * Фермы игрока. Без player — фермы текущего игрока, как было всегда. В
 * одновременной фазе снабжения «текущий» — лишь якорь хода, а фермы нужны
 * игрока, за которого раздается снабжение (selectSupplyActingPlayer): его и
 * передавайте. Явный null (игрока нет) — ферм нет
 *
 * @param {Object} state
 * @param {Object|null} [player]
 * @returns {string[]}
 */
export const getPlayerFarms = (state, player) => {
  const citiesCache = selectCitiesCache(state);
  if (player === undefined) {
    const currentPlayer = selectCurrentPlayer(state)
    return getFarmsOfPlayerCities(citiesCache, currentPlayer.color);
  }

  return player ? getFarmsOfPlayerCities(citiesCache, player.color) : [];
}
